module.exports = __webpack_public_path__ + "img/vip-mobile-1.b7eab46b.jpeg";